export const PARAM_DISPLAY_NAMES = {
  DataSource: {
    owner_id: 'Owner ID',
    status: 'Status',
    org_id: 'Organization ID',
    source_type: 'Source Type',
    data_credentials_id: 'Credential ID',
    source_config: 'Config',
    name: 'Name',
    description: 'Description',
    data_sink_id: 'From Destination ID',
    vendor_endpoint_id: 'Endpoint ID',
    template_config: 'Template Config',
  },
  DataSet: {
    owner_id: 'Owner ID',
    status: 'Status',
    org_id: 'Organization ID',
    output_schema: 'Schema',
    name: 'Name',
    description: 'Description',
    output_schema_annotations: 'Annotations',
    parent_data_set_id: 'Derived from Nexset',
    code_container_id: 'Transform ID',
    data_source_id: 'Detected from Source',
  },
  DataSink: {
    sink_type: 'Destination Type',
    data_credentials_id: 'Credential ID',
    sink_config: 'Config',

    owner_id: 'Owner ID',
    status: 'Status',
    org_id: 'Organization ID',
    data_set_id: 'Writing Nexset ID',
    name: 'Name',
    description: 'Description',
    data_map_id: 'Lookup ID',
  },
  CodeContainer: {
    name: 'Name',
    description: 'Description',
    code: 'Transform Code',
    owner_id: 'Owner ID',
    org_id: 'Organization ID',
    code_type: 'Code Language',
    custom_config: 'Function Arguments',
  },
  DataSchema: {
    name: 'Name',
    description: 'Description',
    schema: 'Schema',
    owner_id: 'Owner ID',
    org_id: 'Organization ID',
  },
};
